import { extend } from 'flarum/common/extend';

export default () => {
    const { DraftsListItem } = flarum.extensions['fof-drafts'].components;

    extend(DraftsListItem.prototype, 'view', function() {
        const { draft } = this.attrs;
        this.canSchedule = this.canSchedule && !draft.scheduledValidationError();
    });
}
